<template>
  <div class="body">
    <div class="body-left-table">
      <!-- <el-card> -->
      <el-table border :data="tableData" style="width: 90%">
        <el-table-column
          fixed="left"
          prop="free_name"
          label="费用名称"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="mch_no" label="商户id" width="120">
        </el-table-column>
        <el-table-column prop="free_no" label="费用id" width="120">
        </el-table-column>
        <el-table-column prop="free_type" label="费用类型" width="120">
        </el-table-column>
        <el-table-column prop="other1" label="详细说明" width="120">
        </el-table-column>
        <el-table-column prop="flag" label="状态" width="100">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- </el-card> -->
    </div>
    <div class="body-right-form">
      <el-tabs v-model="el_tabs">
        <el-tab-pane label="新建费用种类" name="first">
          <div>
            <freeForm :formtype="'create'"></freeForm>
          </div>
        </el-tab-pane>
        <el-tab-pane label="修改" name="second">
          <div>
            <freeForm :formtype="'update'" ref="updateFeeRef"></freeForm>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import freeForm from "./components/feeForm.vue";
import {FreeDir} from "@/api/index";
export default {
  components: {
    freeForm
  },
  data() {
    return {
      el_tabs: "first",
      tableData: []
    };
  },
  async mounted() {
    console.log(this.DateNow());
    let res = await FreeDir({
      access_token: localStorage.getItem("access_token"),
      mch_no: localStorage.getItem("mch_id")
    });

    console.log(res);
  },
  methods: {
    handleClick(row) {
      this.el_tabs = "second";
      this.$refs.updateFeeRef.updateFee(row);
    }
  }
};
</script>
<style scoped>
.body {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 1%;
}
.body-left-table {
  width: 48%;
  height: 98%;
  display: inline-block;
}
.body-right-form {
  position: absolute;
  width: 50%;
  height: 98%;
  display: inline-block;
}
</style>
